module.exports = __webpack_public_path__ + "media/mypage/images/expanded-options-d523e49ab1774fa0652a5defe2feee50.png";